import axios from "axios";

const server = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
});

server.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;

    if (!config) {
      return Promise.reject(error);
    }

    config.__retryCount = config.__retryCount || 0;

    if (
      error.response?.status === 429 &&
      config.__retryCount < 3
    ) {
      config.__retryCount++;

      console.log(
        `429 received. Retry ${config.__retryCount}/3 for ${config.url}`
      );

      await new Promise((r) => setTimeout(r, 15000));

      return server(config);
    }

    return Promise.reject(error);
  }
);

export default server;